import { SubmitBtnProvider } from 'contexts/SubmitBtnContext'
import SendSmsForm from "./SendSmsForm"

export default function ModalSendSms({ task }) {
  return (
    <SubmitBtnProvider>
      <SendSmsForm task={task} />
    </SubmitBtnProvider>
  )
}